import React from 'react';

const AuthButtons = ({ onLoginClick, onPricingClick }) => (
  <div className="hidden md:flex items-center gap-3">
    <button
      onClick={onLoginClick}
      className="text-small font-bold text-ink-light hover:text-ink transition-colors"
    >
      Sign In
    </button>
    <button
      onClick={onPricingClick}
      className="bg-ink text-white border-[1.5px] border-ink px-4 py-2 text-small-sm font-bold uppercase tracking-wide rounded-lg hover:bg-ink-soft transition-colors"
    >
      Join the Community
    </button>
  </div>
);

export default AuthButtons;
